
// IMPORTANT: This file is auto generated! Do not manually edit or checkin!
// tslint:disable
export const GIT_INFO = {
  "dirty": false,
  "raw": "617c58e",
  "hash": "617c58e",
  "distance": null,
  "tag": null,
  "semver": null,
  "suffix": "617c58e",
  "semverString": null
};
